
export enum UsageStepState
{
    BeforeStart = "BeforeStart",
    InUse = "InUse",
    AfterEnd = "AfterEnd",
    Omitted = "Omitted",
    StoppedBeforePlannedEnd = "StoppedBeforePlannedEnd",
    Interrupted = "Interrupted"
}
